import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const ExploreCoursesSlider = () => {
  const [coursesInfo, setCoursesInfo] = useState([]);
  // const [profileImg, setProfileImg] = useState([]);
  const [loading, setLoading] = useState(true);
  // Sample Institute Data

  const fetchCourses = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getCoursesDetails`);
      // console.log(response.data);
      setCoursesInfo(response.data);
      // setProfileImg(response.data.data.profileImg);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchCourses();
  }, []);

  return (
    <div className="institute-slider-container event-slider">
    {loading ? (
      <p>Loading institutes...</p>
    ) : coursesInfo.length > 0 ? (
      <OwlCarousel
        className="owl-theme"
        loop
        margin={15}
        nav
        autoplay
        autoplayTimeout={3000}
        responsive={{
          0: { items: 1 },
          600: { items: 2 },
          1000: { items: 3 },
        }}
      >
        {coursesInfo.map((course, index) => (
          <div class="pd-20"  key={course.id || index}>
          <div class="course-item wow fadeInUp" data-wow-delay=".25s">      
              <div class="course-img">
                  <span class="curve"></span>
                  {/* <span class="course-tag">6258 Colleges</span> */}
                  <span class="course-tag">Rs.{course.course_price}</span>
                  {/* <img src={`${Image_Base_Url}${course.course_image_path}`} alt="" /> */}
                   <img
                    src={
                      (() => {
                        try {
                          const parsed = JSON.parse(course.course_image_name);
                          return Array.isArray(parsed)
                            ? `${Image_Base_Url}${parsed[0]?.image_path}`
                            : `${Image_Base_Url}${parsed}`;
                        } catch {
                          return `${Image_Base_Url}${course.course_image_path || course.course_image_name}`;
                        }
                      })()
                    }
                    alt={course.course_title}
                  />
                  <a href="#" class="btn"><i class="far fa-link"></i></a>
              </div>
              <div class="course-content">
                  <div class="course-meta">
                      <span class="course-meta-left">
                        {/* <i class="far fa-book"></i>  */}
                      </span>
                  </div>
                  <h4 class="course-title">
                      <a href="#">{course.course_title}</a>
                  </h4>
                  
                  <div class="course-bottom">
                      <div class="course-bottom-left">
                          <span>Top Institute: {course.top_institute}</span> 
                      </div> 
                  </div>
                  <div class="course-bottom">
                      <div class="course-bottom-left">
                          <span>Entrance Exam: {course.entrance_exam}</span> 
                      </div> 
                  </div>
                  <div class="course-bottom">
                      <div class="course-bottom-left">
                          <span>Duration: {course.course_duration}</span> 
                      </div> 
                  </div> 
                    <div class="text-center">
                    <Link className="theme-btn" to={`/CourseDetail/${course.id}`}>
                        Explore Now<i class="fas fa-arrow-right-long"></i>
                    </Link>
                   {/* <a href="#" class="theme-btn"><i class="fas fa-arrow-right-long"></i></a>  */}
                   </div>   
              
              </div>
          </div>
    </div>
        ))}
      </OwlCarousel>
    ) : (
      <p>No courses available.</p>
    )}
  </div>
  );
};

export default ExploreCoursesSlider;